<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            :showAdd="showAdd"
            :clearable="clearable"
            @change="$emit('change', $event)"
            :dense="dense"
        >

             <template v-if="showDescription" v-slot:dataItem="{ item }">
                <span class="mb-2">
                    <strong>{{ item.name }}</strong>
                    <small v-if="item.description"><br/> {{ item.description }}</small>
                </span>
            </template>
    
        </sys-select-base>
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectDynamicDivisionType',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        dense: {
            type: Boolean,
            default: false
        },
        showDescription: {
            type: Boolean,
            default: false
        }
        
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },
    },
    methods: {
        ...mapActions('dynamicGeneration', ['ActionIndexDynamicDivisionTypes']),   
        
        async getItems() {

            this.loading = true;
            this.items = [];

            await this.ActionIndexDynamicDivisionTypes()
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.model;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

    newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
            }
        }
    },
    
}
</script>